// @flow

import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { getPlayerDetails } from '../../../redux/actions/playerDetails';
import PlayerCardHeader from './PlayerCardHeader/PlayerCardHeader';
import Gamelogs from './Gamelogs/Gamelogs';
import News from './News/News';
import Articles from './Articles/Articles';
import './PlayerCard.css';

// header

type Props = {
    cookies: { [key: string]: any },
    player: { [key: string]: any },
    playerDetails: { [key: string]: any },
    userDetails: { [key: string]: any },
    show: boolean,
    sport: string,
    onClose: Function,
    clickPlayerCard: Function,
    getPlayerDetails: Function
};

type State = {
    loginCookie: string
};

class PlayerCard extends Component<Props, State> {
    constructor(props) {
        super(props);
        const { cookies } = this.props;
        this.state = {
            loginCookie: cookies.get('flid') || '0'
        };
    }
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    componentDidUpdate(previousProps) {
        if (
            this.props.player !== null &&
            this.props.player.player_id !== undefined &&
            this.props.player !== previousProps.player
        ) {
            this.props.getPlayerDetails(
                this.props.player.player_id,
                Moment(this.props.player.event_date_time).format('YYYY-MM-DD'),
                this.state.loginCookie
            );
        }
    }
    render() {
        if (!this.props.show) {
            return null;
        }

        return (
            <div className={'backdrop'} onClick={this.props.onClose}>
                <div className={'modal-window'} onClick={this.props.clickPlayerCard}>
                    <div className={'card-header'}>
                        <PlayerCardHeader
                            player={this.props.player}
                            sport={this.props.sport}
                            onClose={this.props.onClose}
                            playerDetails={this.props.playerDetails}
                            userDetails={this.props.userDetails}
                        />
                    </div>
                    <Gamelogs player={this.props.player} sport={this.props.sport} />
                    <div className={'row row-no-margins'}>
                        <div className={'col-md-7'}>
                            <News player={this.props.player} />
                        </div>
                        <div className={'col-md-5'}>
                            <Articles sport={this.props.sport} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userDetails: state.userDetails,
        playerDetails: state.playerDetails
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPlayerDetails: (playerId, propsDate, sessionId) => dispatch(getPlayerDetails(playerId, propsDate, sessionId))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withCookies(PlayerCard));



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/PlayerCard.js